import axios from 'axios';

export const PR_WEBHOOK_URL =
  'https://qgold-n8n.off-chainventures.com/webhook/post-pr-from-admin';

const EASTERN_TZ = 'America/New_York';

// Offset (ms) of America/New_York from UTC at the given UTC timestamp.
// Negative for New York (e.g. -4h in summer, -5h in winter).
function easternOffsetMs(utcTimestamp) {
  const dtf = new Intl.DateTimeFormat('en-US', {
    timeZone: EASTERN_TZ,
    hour12: false,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
  const parts = {};
  for (const { type, value } of dtf.formatToParts(new Date(utcTimestamp))) {
    parts[type] = value;
  }
  const asUtc = Date.UTC(
    Number(parts.year),
    Number(parts.month) - 1,
    Number(parts.day),
    parts.hour === '24' ? 0 : Number(parts.hour),
    Number(parts.minute),
    Number(parts.second)
  );
  return asUtc - utcTimestamp;
}

/**
 * Convert a "YYYY-MM-DDTHH:mm" wall-clock time in America/New_York
 * (DST-aware) to a UTC ISO string like "2026-07-01T18:00:00Z".
 * Returns '' for invalid input.
 */
export function easternToUtcIso(localValue) {
  if (!localValue || typeof localValue !== 'string') return '';
  const match = localValue.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/);
  if (!match) return '';
  const [, y, m, d, h, min] = match.map(Number);
  const utcGuess = Date.UTC(y, m - 1, d, h, min);
  if (Number.isNaN(utcGuess)) return '';
  let ts = utcGuess - easternOffsetMs(utcGuess);
  // Re-check near DST boundaries: offset at the corrected instant may differ.
  const secondOffset = easternOffsetMs(ts);
  ts = utcGuess - secondOffset;
  return new Date(ts).toISOString().replace('.000Z', 'Z');
}

export function submitPrPost(payload) {
  return axios.post(PR_WEBHOOK_URL, payload);
}
